const PUBLIC_PROD_HOST_PATTERN = /^(www\.)?bytecookie\.net$/i;
const PUBLIC_PROD_BASE_URL_PATTERN = /^https?:\/\/(www\.)?bytecookie\.net$/i;

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, '');
const defaultRobots = 'index, follow';
const nonProdRobots = 'noindex, nofollow';

export const isPrerenderBuild = () => process.env.VUE_APP_PRERENDER === 'true';

export const isPublicSiteBuild = () => process.env.VUE_APP_PUBLIC_SITE === 'true' || isPrerenderBuild();

export const isPublicProdHost = () => PUBLIC_PROD_HOST_PATTERN.test(window.location.host);

export const isPublicProdBuildTarget = () => {
  const configuredBaseUrl = normalizeBaseUrl(process.env.VUE_APP_PUBLIC_BASE_URL?.trim() || '');

  if (configuredBaseUrl) {
    return PUBLIC_PROD_BASE_URL_PATTERN.test(configuredBaseUrl);
  }

  const deployBucket = process.env.DEPLOY_BUCKET?.trim();
  if (deployBucket) {
    return PUBLIC_PROD_HOST_PATTERN.test(deployBucket);
  }

  const environment = process.env.ENVIRONMENT?.trim();
  if (environment?.length) {
    return environment === 'prod';
  }

  return isPublicSiteBuild();
};

export const shouldUsePublicLandingpage = () => isPublicProdHost() || isPublicProdBuildTarget();

export const getPublicBaseUrl = () => {
  const configuredBaseUrl = process.env.VUE_APP_PUBLIC_BASE_URL?.trim();

  if (configuredBaseUrl) {
    return normalizeBaseUrl(configuredBaseUrl);
  }

  if (isPublicSiteBuild()) {
    return 'https://www.bytecookie.net';
  }

  return normalizeBaseUrl(window.location.origin);
};

export const getDefaultRobots = () => {
  if (!isPublicProdHost() && !isPublicProdBuildTarget()) {
    return nonProdRobots;
  }

  return process.env.VUE_APP_ROBOTS?.trim() || defaultRobots;
};
